/**
 * @description dispacth方法修改
 */

import StoreCreator from './storeCreator';

const dispatch = (type: string, payload?: any) => {
    if (StoreCreator.store) {
        StoreCreator.store.dispatch({
            type,
            payload,
        });
    }
};

export default dispatch;
